import { ExamPracticalSectionId, ExamPracticalSectionSubmissionToken } from '../../commonv3/types/courseExams';
import { AdminApiV3 } from './base';
import {
    PracticalSectionSubmission,
    PracticalSectionSubmissionId,
    PracticalSectionSubmissionIndex,
} from '../types/practicalSubmissions';
import { PagedList } from '../../admin/types/pagination';
import { MainV3ApiBase } from '../../mainv3/apis/base';

export const PracticalSubmissionApis = {
    async findAll(sectionId: ExamPracticalSectionId, page = 1): Promise<PagedList<PracticalSectionSubmissionIndex>> {
        return PagedList.fromJson(
            await AdminApiV3.appendPath('exam_practical_sections/:sectionId/practical_section_submissions')
                .bind({ sectionId })
                .get({ page })
        );
    },
    create(
        sectionId: ExamPracticalSectionId,
        submission: PracticalSectionSubmission
    ): Promise<PracticalSectionSubmission> {
        return AdminApiV3.appendPath('exam_practical_sections/:sectionId/practical_section_submissions')
            .bind({ sectionId })
            .post(submission);
    },
    update(
        id: PracticalSectionSubmissionId,
        submission: Partial<PracticalSectionSubmission>
    ): Promise<PracticalSectionSubmission> {
        return AdminApiV3.appendPath('practical_section_submissions/:id')
            .bind({ id })
            .put(submission);
    },
    destroy(id: PracticalSectionSubmissionId): Promise<void> {
        return AdminApiV3.appendPath('practical_section_submissions/:id')
            .bind({ id })
            .delete();
    },
    confirmSubmissionUserComments(token: ExamPracticalSectionSubmissionToken) {
        return MainV3ApiBase.appendPath('practical_section_submissions')
            .withId(token)
            .appendPath('confirm_comment')
            .post();
    },
};
